MoyaComponents.register('extras.dotlottie', [
	'https://unpkg.com/@dotlottie/player-component@1.0.0/dist/dotlottie-player.js',
], () => {

});
